var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'app--left': _vm.$root.show.appLeft, 'app--wide': _vm.appWide
    }
  }, [_c('app-nav'), _vm._v(" "), _c('app-left'), _vm._v(" "), (!_vm.$root.user['@id']) ? _c('modal-auth') : _vm._e(), _vm._v(" "), _c(_vm.$root.route.view, {
    tag: "component",
    nativeOn: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 0
      }
    }
  }, [_c('section', {
    staticClass: "section-content"
  })]), _vm._v(" "), _c('app-sync', {
    nativeOn: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 0
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 103
// module chunks = 1